export default __webpack_public_path__ + "static/media/creta_text_logo.05015b36.png";